import Tr from 'translations/Translations';

const createItem = (label, value) => ({
	label,
	value
})

export const VARIANT_CODE = {
	RANGE: 'BETWEEN',
	SMALLER: 'SMALLER_THAN',
	BIGGER: 'BIGGER_THAN',
}

export default [
	createItem(Tr('criteria_element_v_range'), VARIANT_CODE.RANGE),
	createItem(Tr('criteria_element_v_smaller'), VARIANT_CODE.SMALLER),
	createItem(Tr('criteria_element_v_bigger'), VARIANT_CODE.BIGGER),
]